import BusinessRulesPage from "../../pages/documentation/BusinessRulesPage";

const route = {
  key: "businessRules",
  path: "/business-rules",
  component: BusinessRulesPage,
  private: true,
  layout: "main",
  icon: "faScaleBalanced",
  group: "documentation",
  order: 20,
};

export default route;
